import { NumPair, Point, Vector, Vector2 } from "../Misc/Utils";

export module PointOps{

    export function add(pointA : Point, pointB : Point) : Point{
        return [pointA[0]+pointB[0], pointA[1]+pointB[1] ];
    }

    export function subtract(pointA : Point, pointB : Point) : Point{
        return [pointA[0]-pointB[0], pointA[1]-pointB[1]];
    }

    export function difference(pointA : Point, pointB : Point) : Point{
        return [Math.abs(pointA[0]-pointB[0]), Math.abs(pointA[1]-pointB[1])];
    }

    export function multiply(point : Point, multiplicand : number) : Point{
        return [point[0]*multiplicand, point[1]*multiplicand];
    }

    export function div(point: Point, divisor: number): Point{
        return  [point[0]/divisor, point[1]/divisor];
    }

    export function divByPair(point: Point, numPair: NumPair): Point{
        return  [point[0]/numPair[0], point[1]/numPair[1]];
    }

    export function mid(pointA : Point, pointB : Point) : Point{
        return [(pointA[0]+pointB[0])/2, (pointA[1]+pointB[1])/2];
    }

    export function dist(pointA : Point, pointB : Point) : number{
        var diff : Point = subtract(pointA, pointB);
        return Math.sqrt( diff[0]*diff[0] + diff[1]*diff[1] );
    }

    export function moveByVector2(p: Point, v: Vector2): Point{
        return [p[0]+v[0], p[1]+v[1]];
    }

    export function containedInRect( point : Point, rectXY : Point, rectWH : Point) : boolean{
        if( point[0] > rectXY[0] && point[0] < rectXY[0]+rectWH[0]
            && point[1] > rectXY[1] && point[1] < rectXY[1]+rectWH[1]){
            return true;
        }
        return false;
    }

    export function containedInCircle(point : Point, centre : Point, radius : number) : boolean{
        var dist = subtract(point, centre);
        if( dist[0]*dist[0] + dist[1]*dist[1] < radius * radius ){
            return true;
        }
        return false;
    }

    export function interpolate(pointA : Point, pointB : Point, interpolant : number) : Point{
        var diff : Point = subtract(pointB, pointA);
        return add(pointA, multiply(diff, interpolant));
    }

    export function quadInterpolate(pointA : Point, pointB : Point, pointC : Point, interpolant : number) : Point{
        var t1 = 1-interpolant;
        var t2 = interpolant * interpolant;
        // x(t) = (1-t)(1-t)A + 2t(1-t)B + (t^2)C 
        return PointOps.add(PointOps.add( PointOps.multiply(pointA, t1*t1), PointOps.multiply(pointB, 2*interpolant*t1)), PointOps.multiply(pointC, t2));
    }

    export function toVector(a: Point): Vector{
        return [a[0], a[1], 1];
    }

    export function toVector2(a: Point): Vector2{
        return [a[0], a[1]];
    }

    export function equal(a: Point, b: Point): boolean{
        return a[0]==b[0] && a[1]==b[1];
    }
}